(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/constants.js');

'use strict';

const CONSTANTS = {
  LOCATION_TYPES: {
    NONE: 'NONE',
    HOME: 'HOME',
    CURRENT: 'CURRENT',
    OTHER: 'OTHER'
  },
  PAYOUT_KEYS: {
    LATEST_DRAW: 'latestDraw',
    THIS_YEAR: 'thisYear',
    SINCE_LAUNCH: 'sinceLaunch',
    SPECIFIC_DRAWS: 'specifiedDraws'
  },
  LOCATION_NAME_DEFAULT: 'Min lyckoplats',
  LOCATION_NAME_MOBILE: 'Min lyckoplats❤️',
  PRICE_PER_WEEK: 40,
  FIRST_ZOOM_LEVEL: 11,
  PLACE_PIN_ZOOM_LEVEL: 15,
  DRAWS: {
    NUMBER_OF_WEEKS: 4,
    DRAWS_PER_WEEK: 3
  },
  DRAW_STATE: {
    OPEN: 2,
    REG_CLOSED: 3,
    CANCEL_CLOSED: 4,
    FINALIZED: 20
  },
  CORRECTION_STEP: {
    START: 0,
    TOPWIN: 1,
    PLACE: 2,
    DISTANCE: 3,
    RESULT: 4
  },
  CORRECTION_TRIGGER_TYPE: {
    CLICK: 1,
    AUTOMATED: 2
  },
  GEO_SEARCH_TYPES: {
    PLACE: 'place',
    ADDRESS: 'address'
  },
  GEO_ACCURACY_THRESHOLD: 60,
  CONFETTI_COLORS: [[32, 115, 229], [22, 255, 171], [255, 93, 57], [221, 236, 255], [213, 255, 240]]
};
if (svs.isServer) {
  module.exports = CONSTANTS;
} else {
  Object.assign(svs.lyckoplatsen.components.shared_constants, {
    CONSTANTS
  });
}

 })(window);